import React from 'react'
import {
  Table,
  Button
} from 'semantic-ui-react'
// Local
import ReveleerButton from '../../common/ReveleerButton'
import { shouldRenderReskin2025 } from '../../../constant'

type Props = {
  columns: number
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

function TablePaginationFooter(
  props: Props
): JSX.Element {
  const {
    columns,
    currentPage,
    totalPages,
    onPageChange
  } = props

  const renderPageButton = (page: number) => {
    const isActive = page === currentPage

    if (!shouldRenderReskin2025) {
      return (
        <Button
          key={ page }
          className={ 
            isActive 
              ? 'active'
              : ''
          }
          color={ 
            isActive 
              ? 'blue'
              : undefined 
          }
          size="small"
          onClick={ () => onPageChange(page) }
          style={
            {
              margin: '0 2px'
            }
          }
        >
          { page }
        </Button>
      )
    }

    return (
      <ReveleerButton
        key={ page }
        buttonLabel={ String(page) }
        buttonSize="small"
        buttonType={
          isActive
            ? 'primary'
            : 'secondary'
        }
        id={ `table-pagination-page-${page}` }
        isDisabled={ false }
        onClick={ () => onPageChange(page) }
        type="button"
      />
    )
  }

  const pageNumbers = Array.from(
    { length: totalPages },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    (_, i) => i + 1
  ).map(renderPageButton)

  return (
    <Table.Footer>
      <Table.Row>
        <Table.HeaderCell
          className="table-footer-max"
          colSpan={ columns }
          style={ { textAlign: 'center' } }
        >
          { pageNumbers }
        </Table.HeaderCell>
      </Table.Row>
    </Table.Footer>
  )
}

export default TablePaginationFooter
